import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import apiInstanceV2 from '../../Apis/AxiosV2';
import { postSessionStorageLoader } from '../../Apis/functions';
import {DEVICE_SERVICE, STATUS_SERVICE} from '../EndPoints';

export const GetListStatusDevice = createAsyncThunk(
    'devices/getListStatusDevice',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(STATUS_SERVICE.getListStatus)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

// anti-pass-back-type/get-all company-module device-controller

export const GetAntiPassBackType = createAsyncThunk(
    'devices/getAntiPassBackType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(DEVICE_SERVICE.getAntiPassBackType)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// escort-mode/get-all company-module device-controller

export const GetEscortMode = createAsyncThunk('devices/getEscortMode', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .get(DEVICE_SERVICE.getEscortMode)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// authentication/get-all company-module device-controller

export const GetAuthentication = createAsyncThunk(
    'devices/getAuthentication',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(DEVICE_SERVICE.getAuthentication)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// List all the Company Devices with zone=null by id
export const GetAllDevicesZoneNull = createAsyncThunk(
    'devices/getAllDevicesZoneNull',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(DEVICE_SERVICE.getAllDevicesZoneNull)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetAllDevices = createAsyncThunk(
    'devices/getAllDevices',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(DEVICE_SERVICE.getAllDevices)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// create device /create company-module device-controller

export const CreateDeviceApi = createAsyncThunk('devices/createDeviceApi', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .post(DEVICE_SERVICE.createDeviceApi, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// create airbnk-lock /create company-module device-controller

export const CreateAirbnkLock = createAsyncThunk('devices/createAirbnkLock', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .post(DEVICE_SERVICE.createAirbnkLock, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// get device smartlock in Zone /get company-module device-controller

export const GetDeviceSmartlock = createAsyncThunk(
    'employeeZones/getDeviceSmartlock',
    async (id, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${DEVICE_SERVICE.getDeviceSmartlock}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get device airbnkLock /get company-module device-controller

export const GetDeviceAirbnkLock = createAsyncThunk(
    'devices/getDeviceAirbnkLock',
    async (id, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${DEVICE_SERVICE.getDeviceAirbnkLock}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get device details by id /get company-module device-controller

export const GetDeviceDetails = createAsyncThunk('devices/getDeviceDetails', async (id, { dispatch, getState }) => {
    const result = await apiInstance
        .get(`${DEVICE_SERVICE.getDeviceDetails}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// list logs device by id /get company-module device-controller
export const GetDeviceLog = createAsyncThunk('devices/getDeviceLog', async (id, { dispatch, getState }) => {
    const result = await apiInstance
        .get(`${DEVICE_SERVICE.getDeviceLog}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// Get QR body by id /get company-module device-controller
export const GetQrCode = createAsyncThunk('devices/getQrCode', async (id, { dispatch, getState }) => {
    const result = await apiInstance
        .get(`${DEVICE_SERVICE.getQrCode}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// list logs device by id pageable /get company-module device-controller
export const GetDeviceLogPageable = createAsyncThunk(
    'devices/getDeviceLogPageable',
    async ({ id, body }, { dispatch, getState }) => {
        postSessionStorageLoader(true);
        const result = await apiInstance
            .post(`${DEVICE_SERVICE.getDeviceLogPageable}${id}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// add free device to Zone /add company-module device-controller

export const AddFreeDevice = createAsyncThunk('devices/addFreeDevice', async (params, { dispatch, getState }) => {
    const { id, zoneId } = params;
    const result = await apiInstance
        .put(DEVICE_SERVICE.addFreeDevice(id, zoneId))
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// Update device Zone to Null /update company-module device-controller

export const RemoveDevicesZone = createAsyncThunk('devices/removeDevicesZone', async (body, { dispatch, getState }) => {
    const result = await apiInstance
        .put(DEVICE_SERVICE.removeDevicesZone, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// update device /update company-module device-controller

export const UpdateDeviceApi = createAsyncThunk('devices/updateDeviceApi', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .put(DEVICE_SERVICE.updateDeviceApi, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// update Airbnk /update company-module device-controller
export const UpdateAirbnk = createAsyncThunk('devices/updateAirbnk', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .put(DEVICE_SERVICE.updateAirbnk, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// List all devices by mode ids
export const GetAllDevicesByModeIds = createAsyncThunk('devices/getAllDevicesByModeIds', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .post(DEVICE_SERVICE.getAllDevicesByModeIds, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// Paginated device search filtered by mode (device-service/v1/simple-mode-search)
export const SimpleModeSearchDevices = createAsyncThunk(
    'commons/simpleModeSearchDevices',
    async (body) => {
        const result = await apiInstance
            .post(DEVICE_SERVICE.simpleModeSearch, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const GetAssigned = createAsyncThunk(
    'device-service/getAssigned',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${DEVICE_SERVICE.getAssigned}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetNoAssigned = createAsyncThunk(
    'device-service/getNoAssigned',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${DEVICE_SERVICE.getNoAssigned}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const CreateEmployee = createAsyncThunk(
    'device-service/createEmployee',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${DEVICE_SERVICE.createEmployee}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const CreateDepartment = createAsyncThunk(
    'device-service/createDepartment',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${DEVICE_SERVICE.createDepartment}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Open door by deviceId + OTP
export const OpenDoorByDeviceOtp = createAsyncThunk(
    'devices/openDoorByDeviceOtp',
    async ({ deviceId, code }, { dispatch, getState }) => {

        const result = await apiInstance
            .get(`${DEVICE_SERVICE.openDoorByDeviceOtp}${deviceId}/otp/${code}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    }
);



